<script>
import { Line, mixins } from 'vue-chartjs'
import { getStyle, hexToRgba } from '@coreui/coreui-pro/dist/js/coreui-utilities'
import { CustomTooltips } from '@coreui/coreui-plugin-chartjs-custom-tooltips'
import { random } from '@/shared/utils'
import moment from 'moment'


export default {
  extends: Line,
  props: ['height', 'options', 'chartData', 'period'],
  mixins: [mixins.reactiveProp],

  mounted () {
    const brandSuccess = getStyle('--success') || '#4dbd74'
    const brandInfo = getStyle('--info') || '#20a8d8'
    const brandDanger = getStyle('--danger') || '#f86c6b'

    let d = this.chartData;
    
    let onlineUsers = {
      data: [],
      label: 'Online Teammates',
      borderColor: '#20c997',
      yAxisID: 'ocounts',
      fill: true,
      backgroundColor: 'rgb(32, 201, 151, 0.18)',  // same color but using RGB notation for opacity
      borderWidth: this.period == 'Week' || this.period == '2Weeks' ? 1.5 : 3,
      borderJoinStyle: 'miter',
    }

    let minOnlineUsers = {
      data: [],
      label: 'Min. Online Teammates',
      borderColor: '#258e6f',
      yAxisID: 'ocounts',
      fill: true,
      backgroundColor: 'rgb(37, 142, 111, 0.12)',  // same color but using RGB notation for opacity
      borderWidth: this.period == 'Week' || this.period == '2Weeks' ? 1.5 : 3,
      borderJoinStyle: 'miter',
    }

    let xAxisLabels = []

    let options = { weekday: 'short', year: 'numeric', month: 'long', day: 'numeric' }
    Object.keys(d).forEach(function(key) {
      // add label
      xAxisLabels.push(moment.unix(key).format('MMM Do hA'))

      // now fill in data
      let row = d[key]
      onlineUsers['data'].push(row.users_online)
      //minOnlineUsers['data'].push(row.min_users_online)

    })

    this.renderChart({
      labels: xAxisLabels,
      datasets: [onlineUsers]  // [onlineUsers, minOnlineUsers]
    }, 
    // chart options
    {
      elements: {
        point: {
          radius: 0,
          hitRadius: 14, 
          hoverRadius: 8
        }
      },
      tooltips: {
        enabled: true,
        // custom: CustomTooltips,
        intersect: true,
        mode: 'index',
        position: 'nearest',
        callbacks: {
          labelColor: function (tooltipItem, chart) {
            return { backgroundColor: chart.data.datasets[tooltipItem.datasetIndex].borderColor }
          }
        }
      },
      maintainAspectRatio: false,
      legend: {
        display: false
      },
      scales: {
        xAxes: [{
          // stacked: true,
          gridLines: {
            drawOnChartArea: true
          },
          ticks: {
            autoSkip: true,
            maxTicksLimit: 24 // this will need to be dynamic based on time window
          }
          
        }],
        yAxes: [{
          id: 'ocounts',
          position: 'left',
          ticks: {
            beginAtZero: true,
            fontColor: '#20c997',
            precision: 0,
            // max: Math.max.apply(Math, onlineUsers.data) + 5
          },
          gridLines: {
            display: true
          },
          scaleLabel: {
            display: true,
            // fontColor: '#20c997',
            labelString: 'Online Teammates'
          }
        }]
      },

    })
        
  }
}
</script>
